export const api = {
  hostname: process.env.REACT_APP_API_URL || '/api/v1',
};
